import About from "../../../Components/Client/About";

const AboutPage = () => {
  return <About />;
};

export default AboutPage;
